__turbopack_context__.v({
  "className": "w9DJWW_className",
  "variable": "w9DJWW_variable",
});
